import { Middleware } from 'one-ring';

const UnlinkMapping = [
    Middleware.CreateMapping('Company', 'CompanyId'),
    Middleware.CreateMapping('PONumber', 'PONumber'),
    Middleware.CreateMapping('POHeaderId', 'POHeaderId'),
    Middleware.CreateMapping('SONumber', 'SalesOrderNbr'),
    Middleware.CreateMapping('TransactionType', 'TransactionType'),
    Middleware.CreateMapping('SalesUpdatedDateTime', 'SalesUpdatedDateTime'),
    Middleware.CreateMapping('SalesUpdatedBy', 'SalesUpdatedBy'),
    Middleware.CreateMapping('POLineId', 'POLineId'),
    Middleware.CreateMapping('ItemNbr', 'ItemNbr'),
    Middleware.CreateMapping('Lines', 'Lines'),
    Middleware.CreateMapping('SalesLineUpdatedDateTime', 'SalesLineUpdatedDateTime'),
    Middleware.CreateMapping('SalesLineUpdatedBy', 'SalesLineUpdatedBy'),
    Middleware.CreateMapping('ShipToNumber', 'ShipToNumber'),
    Middleware.CreateMapping('Date', 'Date'),
    Middleware.CreateArrayMapping('Results', 'Results')
];

function ConfigureMiddleware() {
    if (!Middleware.CheckMappingExists('Unlink', 'POST')) {
        Middleware.RegisterMapping('Unlink', 'POST', UnlinkMapping, true);
    }
}

const Unlink = {
    ConfigureMiddleware
};

export default Unlink;
